import { render, staticRenderFns } from "./CommesaDashBoard.vue?vue&type=template&id=636f1d26&"
import script from "./CommesaDashBoard.vue?vue&type=script&lang=js&"
export * from "./CommesaDashBoard.vue?vue&type=script&lang=js&"
import style0 from "./CommesaDashBoard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports